<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil bwlist" style="background:#fff;">
            <a-card>
                <div>
                    <a-tabs default-active-key="1">
                        <a-tab-pane key="1" tab="黑名单">
                            <div class="search">
                                <a-select default-value="all" style="width: 200px" >
                                    <a-select-option value="all">
                                        IP黑名单
                                    </a-select-option>
                                    <a-select-option value="system">
                                        URL黑名单
                                    </a-select-option>
                                </a-select>
                                <a-input style="width:250px;margin-left:12px"></a-input>
                                <a-button type="primary">搜索</a-button>
                            </div>
                            <a-table
                                :columns="columns"
                                :pagination="pagination"
                                :loading="loading"
                                @change="handleTableChange"
                                :data-source="data"
                                >
                            </a-table>
                        </a-tab-pane>
                        <a-tab-pane key="2" tab="白名单" force-render>
                            <div class="search">
                                <a-select default-value="all" style="width: 200px" >
                                    <a-select-option value="all">
                                        IP白名单
                                    </a-select-option>
                                    <a-select-option value="system">
                                        URL白名单
                                    </a-select-option>
                                </a-select>
                                <a-input style="width:250px;margin-left:12px"></a-input>
                                <a-button type="primary">搜索</a-button>
                            </div>
                            <a-table
                                :columns="columns2"
                                :pagination="pagination"
                                :loading="loading"
                                @change="handleTableChange"
                                :data-source="data2"
                                >
                            </a-table>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </a-card>
        </div>
    </div>
</template>

<script>

const columns = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
  },
  {
    title: 'IP黑名单',
    dataIndex: 'age',
    key: 'age',
  }
];
const columns2 = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
  },
  {
    title: 'IP黑名单',
    dataIndex: 'age',
    key: 'age',
  }
];
const data = [
  {
    key: '1',
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park',
    tags: '钢化玻璃',
    url:'http://shop.zzzs2010.cn/14476/index.html?nestshop|360',
    ipaddress:'未读',
    money:'26',
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 42,
    address: 'London No. 1 Lake Park',
    tags: '阳台玻璃',
    url:'http://shop.zzzs2010.cn/14476/index.html?nestshop|360',
    ipaddress:'已读',
    money:'3.2',
  },
];
const data2 = []


export default {
    data(){
        return{
            routes: [
                {breadcrumbName: '首页'},
                {breadcrumbName: '系统管理'},
                {breadcrumbName: '黑白名单'},
            ],
            data,
            columns,
            data2,
            columns2,
            pagination: {},
            loading: false,
        }
    },
    methods:{
            handleTableChange(pagination, filters, sorter) {
            console.log(pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                results: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            });
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/bwlist.vue